import { render, staticRenderFns } from "./CheckoutForm.vue?vue&type=template&id=c2f3895c&scoped=true"
import script from "./CheckoutForm.vue?vue&type=script&lang=ts"
export * from "./CheckoutForm.vue?vue&type=script&lang=ts"
import style0 from "./CheckoutForm.vue?vue&type=style&index=0&id=c2f3895c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f3895c",
  null
  
)

export default component.exports